export enum GAEventTypes {
	SessionStart = 'session_start',
	PageView = 'page_view',
	Scroll = 'scroll',
	UserEngagement = 'user_engagement',
	FirstVisit = 'first_visit',
	Click = 'click',
	AppUpdate = 'app_update',
	ScreenView = 'screen_view',
	LogIn = 'login',
	EventPageTap = 'event_page_tap',
	ViewSearchResults = 'view_search_results',
	FormStart = 'form_start',
	PostViewed = 'post_viewed',
	CommunityCreated = 'community_created',
	EventCreated = 'event_created',
	FirstOpen = 'first_open',
	Purchase = 'purchase',
	ChatOpeningPageTap = 'chat_opening_page_tap',
	LeaveEvent = 'leave_event',
	OSUpdate = 'os_update',
	UserMatchTap = 'user_match_tap',
	PayoutMethodStart = 'payout_method_start',
	PayoutMethodFinish = 'payout_method_finish',
	PymentSubmit = 'payment_submit',
	EventDetails = 'event_details',
	SignUp = 'sign_up',
	JoinEvent = 'join_event',
	CommunityMemberSignUp = 'community_member_sign_up',
	SignUpSuccess = 'sign_up_success',
	MessageSent = 'message_sent',
	PublishJournalButton = 'publish_journal_button',
	CreateJoournalButton = 'create_journal_button',
	CommunityProfileView = 'community_profile_view',
	CreateEventButton = 'create_event_button',
	CreateEventSubmit = 'create_event_submit',
	CommunityProfileTap = 'community_profile_tap',
	SweatMatchSendComment = 'sweat_match_send_comment',
	SweatMatchHelloEmoji = 'sweat_match_hello_emoji',
	Kudos = 'kudos',
	FirebaseCampaign = 'firebase_campaign',
	AppException = 'app_exception',
	CreateCommunity = 'create_community',
	CommunityLetsDoIt = 'community_lets_do_it',
	AppRemove = 'app_remove',
	JoinEventWaitlist = 'join_event_waitlist',
	GroupChatInviteMembers = 'group_chat_invite_members',
	FileDownload = 'file_download',

	// new events
	EventPageView = 'event_page_view',
	EventPurchase = 'event_purchase',
}

export enum GAEventPlatform {
	Web = 'WEB',
	iOS = 'IOS',
	Android = 'ANDROID',
}
